import React, { useEffect } from "react"
import { styles } from "../goods/styles";
import { withRouter  } from 'react-router-dom';

const LoaderKKTModal = (props) => {

    useEffect(() => {          
            const handleBeforeUnload = (e) => {
              e.preventDefault();
              e.returnValue = 'Идёт отправка данных в ККТ. Вы уверены, что хотите покинуть страницу?';
              return e.returnValue;
            };
            window.addEventListener('beforeunload', handleBeforeUnload);
          
            const unblock = props.history.block((location, action) => {
              return 'Идёт отправка данных в ККТ. Вы уверены, что хотите покинуть страницу?';
            });
          
            return () => {
              window.removeEventListener('beforeunload', handleBeforeUnload);
              if (unblock) unblock();
            };
        }, [props.history]);

    return(
        <div>
            <div className="modal fade show" style={{ display: 'block' }}>
                <div className="modal-dialog modal-lg modal-dialog-scrollable" style={{ height: '90%', alignItems: 'center', justifyContent: 'center' }}>
                    <div className="modal-content" style={{ maxWidth: '500px', zIndex: 10000 }}>
                        <div className="modal-body" style={{ minHeight: '150px' }}>
                        <div style={{...styles.tableLoading, marginTop: 100}}>
                            <div className="loader">
                                <div className="kt-spinner kt-spinner--lg kt-spinner--info">
                                </div>
                            </div>
                        </div>
                            <div style={{ color: 'black', fontSize: '1.3rem' }}>Ожидаем ответ от ККТ. Не закрывайте и не обновляйте страницу</div>          
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default withRouter(LoaderKKTModal);